import { clearAllAuth } from 'redux/features/auth/authSlice';
import { isValidAuthEntry } from 'redux/store/persistReducers';
import api from 'services/api';

function applyAuthHeadersFromState(getState) {
  const auth = getState()?.auth;
  if (!auth) return;

  if (isValidAuthEntry(auth.patient, 'patient')) {
    const { user, token } = auth.patient;
    api.defaults.headers.Authorization = `Bearer ${token}`;
    api.defaults.headers['x-user-id'] = user.codPac ?? user.CODPAC;
    api.defaults.headers['x-user-nome'] = user.nome ?? user.NOMEPAC ?? '';
    api.defaults.headers['x-user-role'] = 'PACIENTE';
    return;
  }
  if (isValidAuthEntry(auth.doctor, 'doctor')) {
    const { user, token } = auth.doctor;
    api.defaults.headers.Authorization = `Bearer ${token}`;
    api.defaults.headers['x-user-id'] = user.codMed ?? user.CODMED;
    api.defaults.headers['x-user-nome'] = user.nome ?? user.NOMEMED ?? '';
    api.defaults.headers['x-user-role'] = 'MEDICO';
    return;
  }
  if (isValidAuthEntry(auth.func, 'func')) {
    const { user, token } = auth.func;
    api.defaults.headers.Authorization = `Bearer ${token}`;
    api.defaults.headers['x-user-id'] = user.codFunc ?? user.CODFUNC;
    api.defaults.headers['x-user-nome'] = user.nome ?? user.NOMEFUNC ?? '';
    api.defaults.headers['x-user-role'] = 'FUNCIONARIO';
    return;
  }
  delete api.defaults.headers.Authorization;
  delete api.defaults.headers['x-user-id'];
  delete api.defaults.headers['x-user-nome'];
  delete api.defaults.headers['x-user-role'];
}

export default function authHeadersMiddleware(store) {
  return (next) => (action) => {
    const result = next(action);
    const type = action.type;
    if (type === 'persist/REHYDRATE') {
      const auth = store.getState()?.auth;
      const hasInvalidPersistedSession =
        (auth?.patient && !isValidAuthEntry(auth.patient, 'patient')) ||
        (auth?.doctor && !isValidAuthEntry(auth.doctor, 'doctor')) ||
        (auth?.func && !isValidAuthEntry(auth.func, 'func'));

      if (hasInvalidPersistedSession) {
        store.dispatch(clearAllAuth());
      }

      applyAuthHeadersFromState(store.getState);
      return result;
    }
    if (
      type === 'auth/signInPatient/fulfilled' ||
      type === 'auth/signInDoctor/fulfilled' ||
      type === 'auth/signInFunc/fulfilled'
    ) {
      applyAuthHeadersFromState(store.getState);
      return result;
    }
    if (
      type === 'auth/clearPatient' ||
      type === 'auth/clearDoctor' ||
      type === 'auth/clearFunc' ||
      type === 'auth/clearAllAuth'
    ) {
      applyAuthHeadersFromState(store.getState);
      return result;
    }
    return result;
  };
}
